import React from 'react'
import styled from 'styled-components'
import ReactMarkdown from 'react-markdown'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { personCustomerType } from '../constants/GeneralConstants'

const Header = styled.h3`
    font-weight: bold;
    color: ${props => props.theme.colors.lightGreenText};
    text-transform: uppercase;
`

const Wrapper = styled.div`
    padding-bottom: 3em;
    ul,
    li {
        list-style: inside disc;
        margin-left: 1.5em;
    }
`

class StaticInformationField extends React.Component {
    render() {
        const { header, body } = this.props.data
        const { className, customerType } = this.props

        const isPerson = customerType === personCustomerType

        return (
            <Wrapper className={className}>
                {header &&
                    <Header>
                        {header}
                    </Header>
                }
                {body &&
                <div
                    className={`${isPerson ? 'personText' : ''}`}
                >
                    <ReactMarkdown source={body.body || ''} />
                </div>
                }
            </Wrapper>
        )
    }
}

StaticInformationField.propTypes = {
    data: PropTypes.object,
    header: PropTypes.string,
    body: PropTypes.object,
    className: PropTypes.string,
    customerType: PropTypes.string,
}

const mapStateToProps = (state) => {
    return {
        customerType: state.customerTypeReducer.customerType,
    }
}

export default connect(mapStateToProps)(StaticInformationField)
